import { ComponentProps } from "react";

import styled from "styled-components";

export const ViewFrame = styled.div`
  margin: 0 auto;
  width: 100%;
  min-height: 100vh;
  background-color: var(--palette-surface-dimmed);
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`;

const Content = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: var(--spacing-xxLarge) 0 var(--spacing-xxLarge) 0;
  box-sizing: border-box;

  /* Very small phones (320px - 479px) */
  @media only screen and (max-width: 479px) {
    padding: 1vh 0 1vh 0;
  }

  /* Standard phones (480px - 767px) */
  @media only screen and (min-width: 480px) and (max-width: 767px) {
    padding: 2.5vh 0 2.5vh 0;
  }

  /* Tablets and large phones (768px - 1023px) */
  @media only screen and (min-width: 768px) and (max-width: 1023px) {
    padding: 5vh 0 5vh 0;
  }
`;

export interface GlobalViewProps extends Omit<ComponentProps<"div">, "ref"> {}

export const GlobalView = ({ children, style, ...props }: GlobalViewProps) => {
  return (
    <ViewFrame style={style} {...props}>
      <Content>{children}</Content>
    </ViewFrame>
  );
};
